import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { DebtStatsDto } from "../../../shared/dtos/debt/DebtStatsDto";

interface DebtWidgetProps {
  data: DebtStatsDto;
}

const DebtWidget: React.FC<DebtWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("DEBT");
  const Icon = meta.icon;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            New Debts Amount Today
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "error.main" }}
          >
            {formatCurrency(data.newDebtsAmountToday)}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            New Debts Recorded Today
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", color: "warning.main" }}
          >
            {data.newDebtsToday}
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default DebtWidget;
